export const ENDPOINT_BASE =
  'https://api.halton.io/api/v1/';
